import React, {Fragment, useEffect, useState} from 'react';
import {Route, Switch, useHistory, useParams} from "react-router";
import StickersScreensNewStickerFormat from "../new-sticker-format";
import StickersScreensNewStickerMediaPhoto from "../new-sticker-media-photo";
import StickersScreensNewStickerMediaVideo from "../new-sticker-media-video";
import StickersScreensNewStickerMediaAudio from "../new-sticker-media-audio";
import StickersScreensNewStickerTheme from "../new-sticker-theme";
import StickersScreensNewStickerMessage from "../new-sticker-message";
import StickersScreensNewPreview from "../preview";
import StickerScreensNewVideoRecord from "../new-video-record";
import StickersScreensNewFinish from "../new-sticker-finish";
import ErrorScreen from "../../../../layout/ui/screens/error";
import {addStickerItem} from "../../../store/sticker-show/actions";
import stickerItemsRepositoryBuilder from "../../../domain/factories/StickerItemsRepositoryBuilder";
import { useDispatch } from "react-redux";
import LayoutComponentsLoaderProcessing from "../../../../layout/ui/components/loader-processing";
import { useSticker2 } from "../../../store/sticker-show/hooks";

export default function StickerScreensNew() {
    const {id: stickerId}: { id: string } = useParams();
    const [isAddingNewItem, setIsAddingNewItem] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);
    const dispatch: (any) => Promise<any>  = useDispatch();
    const history = useHistory();
    // The app theme follows the sticker entity in the store (useAppTheme in
    // App), and only the /:id and /stickers/:id screens used to load it.
    // Load it here too so a direct visit to /stickers/:id/new resolves the
    // theme; no scan event, this is not a visit.
    useSticker2(stickerId);

    useEffect(() => {
        let cancelled = false;

        // Creating an item can fail for a perfectly normal reason: on a first
        // visit this POST races the scan request, which configures the sticker,
        // and once configured an anonymous visitor may no longer create one
        // (the server answers NO_PERMISSIONS). That is not an error state - the
        // moment already exists - so check before showing "Oops" and send the
        // visitor to the sticker instead. Genuine failures still surface.
        const handleFailure = async () => {
            try {
                const response = await stickerItemsRepositoryBuilder
                    .buildWithStickerId(stickerId)
                    .load({page: 1, size: 1000});
                const items = response && response.data;
                if (items && items.length > 0) {
                    if (!cancelled) {
                        history.replace(`/stickers/${stickerId}`);
                    }
                    return;
                }
            } catch (e) {
                // fall through - show the error screen
            }
            if (!cancelled) {
                setIsError(true);
            }
        };

        dispatch(addStickerItem(stickerId))
            .then(() => {
                if (stickerId) {
                    localStorage.setItem('stickerForContinue', stickerId);
                }
            })
            .catch(handleFailure)
            .then(() => {
                if (!cancelled) {
                    setIsAddingNewItem(false);
                }
            })
        ;

        return () => { cancelled = true; };
    }, [stickerId])

    if (isError) {
        return <ErrorScreen/>
    }

    if (isAddingNewItem) {
        return <LayoutComponentsLoaderProcessing show={true}/>
    }

    return <Fragment>
        <Switch>
            <Route exact path="/stickers/:id/new/photo" component={StickersScreensNewStickerMediaPhoto}/>
            <Route exact path="/stickers/:id/new/video" component={StickersScreensNewStickerMediaVideo}/>
            <Route exact path="/stickers/:id/new/audio" component={StickersScreensNewStickerMediaAudio}/>
            <Route exact path="/stickers/:id/new/theme" component={StickersScreensNewStickerTheme}/>
            <Route exact path="/stickers/:id/new/message" component={StickersScreensNewStickerMessage}/>
            <Route exact path="/stickers/:id/new/preview" component={StickersScreensNewPreview}/>
            <Route exact path="/stickers/:id/new/video-record" component={StickerScreensNewVideoRecord}/>
            <Route exact path="/stickers/:id/new/finish" component={StickersScreensNewFinish}/>
            <Route exact path="/stickers/:id/new" component={StickersScreensNewStickerFormat}/>
            <Route component={ErrorScreen}/>
        </Switch>
    </Fragment>
}


